const {CardDeck, MilitaryCardTypes}  = require("../../Constants/Constants");
const Card = require("./Card");

class TerritoryCard extends Card{
    constructor(territory)
    {
        super(
            CardDeck.Military,
            MilitaryCardTypes.Territory,
            null,
            territory.GetName(),
            territory.GetAge(),
            territory.GetText(),
            territory.GetEffects(),
        )
        this.territory = territory;
        // What the colony gives while held, shown along the bottom of the card
        this.bonuses = require('../../Constants/Territories/TerritoryEffects')[territory.GetName()]?.bonuses({ age: territory.GetAge() }) ?? {};
    }
}

module.exports = TerritoryCard;